export enum MessageEventType{
    add, 
    edit,
    delete,
    error,
    none
}